import { render, staticRenderFns } from "./NotElegible.vue?vue&type=template&id=2d64fcb4&"
import script from "./NotElegible.vue?vue&type=script&lang=js&"
export * from "./NotElegible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports